import { CartStatus } from '@fcom/dapi/interfaces';
import { isNotEmpty, isPresent } from '@fcom/utils';
import { FinnairCart, FinnairItineraryItemFlight } from '@fcom/dapi/api/models';
import { isFlight } from '@fcom/common-booking/utils/common-booking.utils';

const CART_ERROR_STATES: CartStatus[] = [CartStatus.INITIAL, CartStatus.CREATION_ERROR, CartStatus.LOAD_ERROR];

export const isCartInErrorStateOrDoWeHaveTravelers = (
  cartData: FinnairCart = {} as FinnairCart,
  cartStatus: CartStatus,
  initialRoute: boolean
): boolean => {
  return (
    CART_ERROR_STATES.indexOf(cartStatus) === -1 &&
    (!initialRoute ||
      (initialRoute && isNotEmpty(cartData.passengers) && cartData.passengers.every((t) => !!t.firstName)))
  );
};

export const isAncillariesSkipped = (cartData: FinnairCart = {} as FinnairCart): boolean => {
  return !isPresent(cartData) || !isPresent(cartData.controlData)
    ? false
    : !cartData.controlData.sellAncillariesOutbound && !cartData.controlData.sellAncillariesInbound;
};

export const mapFlightsFromCartData = (cd: FinnairCart): FinnairItineraryItemFlight[] =>
  cd?.bounds.reduce((all, b) => all.concat(...b.itinerary.filter(isFlight)), []) ?? [];

export enum CountryCode {
  KOREA = 'KR',
  CHINA = 'CN',
}
